import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiConfig } from './api.config';

@Injectable({
  providedIn: 'root',
})
export class OrdemDiaService extends ApiConfig {
  constructor(private http: HttpClient) {
    super();
  }
  obter(id) {
    return new Promise(async (resolve) => {
      this.http
        .get('https://project-5082f113-c983-477a-973.uw.r.appspot.com/OrdemDia/Obter?Id='+id)
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => { }
        );
    });
  }

  listarPorProjetoLista(model) {
    return new Promise(async (resolve) => {
      this.http
        .post('https://project-5082f113-c983-477a-973.uw.r.appspot.com/OrdemDia/listarPorProjetoLista', model)
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => { }
        );
    });
  }
  listar(filtro) {
    try {
      return new Promise(async (resolve) => {
        this.http.post('https://project-5082f113-c983-477a-973.uw.r.appspot.com/OrdemDia/Listar', filtro).subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {
            // alert(
              //'Ocorreu um erro ao se conectar ao servidor, verifique sua conexão e tente novamente.'
            // );
            
          }
        );
      });
    } catch (error) {
      alert(error);
    }
  }

  listarPorTag(tag, idRadar, processId = "") {
    try {
      return new Promise(async (resolve) => {
        this.http.get(`https://project-5082f113-c983-477a-973.uw.r.appspot.com/OrdemDia/ListarPorTag?idRadar=${idRadar}&tag=${tag}&processId=${processId}`)
          .subscribe(data => {
            resolve(data);
          }, error => {
          });
      });
    } catch (error) {
      alert(error);
    }
  }
}
